// import { isArray, isFunction, isString, pick } from 'lodash-es'
import { useContext } from 'react'
import { useStore } from 'zustand'
import shallow from 'zustand/shallow'
import StoreContext from './project-context'

function useProjectStore(selector, equalityFn = shallow) {
  const store = useContext(StoreContext)

  // if (isString(selector)) {
  //   return ctx[selector]
  // }

  // if (isArray(selector)) {
  //   return pick(ctx, selector)
  // }

  // if (isFunction(selector)) {
  //   return ctx.useStore(selector)
  // }

  return useStore(store, selector, equalityFn)
}

export default useProjectStore
